<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  @if (isSearching) {
    <div class="kbm-search-loading">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>


        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="properties" formControlName="shortTermRentalId" optionLabel="propertyCode" appendTo="body"
            optionValue="shortTermRentalId" (onChange)="fetchCompendiumShortTermRentalJoinByShortTermRentalId($event)" placeholder="Properties" [filter]="true" filterBy="propertyCode" [showClear]="false"></p-dropdown>
            <label for="shortTermRentalId">Properties</label>
          </span>
        </div>


        @if (isCompendiumLoaded && hasGroupedData) {
          <div class="operation-content">
            <!-- ONE accordion -->
            <p-accordion [multiple]="true">
              <!-- MANY tabs -->
              @for (location of (groupingData | keyvalue: orderByKey); track location; let i = $index) {
                <p-accordionTab
                  [header]="getLocationAreaNameCached(location.key)" [selected]="true">
                  @for (item of location.value; track item) {
                    <div>
                      @if (item?.featureName) {
                        <div>
                          <h6>{{ item.featureName }}</h6>
                          @if (item?.feature) {
                            <span>{{ item.feature }}</span>
                          }
                        </div>
                      }
                      @if (item?.description) {
                        <div>
                          <p [innerHTML]="item.description"></p>
                        </div>
                      }
                      @if (item?.externalUrl) {
                        <div>
                          <img [src]="item.externalUrl">
                        </div>
                      }
                    </div>
                  }
                </p-accordionTab>
              }
            </p-accordion>
          </div>
        }

      </div>
    </div>

  </div>